import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { UploadImageState } from 'src/AppState/UploadImageState/UploadImageState';
import { UploadImg } from 'src/components/UploadImg/UploadImg';
import { InfoHint } from 'src/domains/layouts/shared/formComponents/FormComponents.style';

interface ImageUploadFormPropsTypes {
    imageDesktop: UploadImageState,
    imageTablet: UploadImageState,
    imageMobile: UploadImageState,
    dataTest?: string,
}

export const ImageUploadForm = observer('ImageUploadForm', (props: ImageUploadFormPropsTypes) => {
    const {imageDesktop, imageTablet, imageMobile, dataTest} = props;

    return (
        <>
            <InfoHint>
                    The actual image container width will depend on the user device.
                    For best results no matter the screen size, use images with transparent background.
            </InfoHint>
            <UploadImg
                title='Image Upload Desktop (height: 96px)'
                uploadImageState={imageDesktop}
                hasFullWidthPreview={true}
                dataTest={dataTest}
            />
            <UploadImg
                title='Image Upload Tablet (height: 96px)'
                uploadImageState={imageTablet}
                hasFullWidthPreview={true}
                dataTest={dataTest}
            />
            <UploadImg
                title='Image Upload Mobile (height: 64px)'
                uploadImageState={imageMobile}
                hasFullWidthPreview={true}
                dataTest={dataTest}
            />
        </>
    );
});
